import {
    GET_EXPENSE_CATEGORY,
    GET_EXPENSE_CATEGORY_SUCCESS,
    GET_EXPENSE_CATEGORY_FAIL,
    ADD_NEW_EXPENSE_CATEGORY,
    ADD_EXPENSE_CATEGORY_SUCCESS,
    ADD_EXPENSE_CATEGORY_FAIL,
    UPDATE_EXPENSE_CATEGORY,
    UPDATE_EXPENSE_CATEGORY_SUCCESS,
    UPDATE_EXPENSE_CATEGORY_FAIL,
    GET_EXPENSE_LIST,
    GET_EXPENSE_LIST_SUCCESS,
    GET_EXPENSE_LIST_FAIL,
    ADD_NEW_EXPENSE,
    ADD_EXPENSE_SUCCESS,
    ADD_EXPENSE_FAIL,
    UPDATE_EXPENSE,
    UPDATE_EXPENSE_SUCCESS,
    UPDATE_EXPENSE_FAIL,
  } from './actionTypes';
  
  const initialState = {
    categories: [],
    expenses: [],
    loading: false,
    error: null,
  };
  
  const expenseReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_EXPENSE_CATEGORY:
      case GET_EXPENSE_LIST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case GET_EXPENSE_CATEGORY_SUCCESS:
        return {
          ...state,
          loading: false,
          categories: action.payload,
        };
  
      case GET_EXPENSE_CATEGORY_FAIL:
      case GET_EXPENSE_LIST_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case ADD_NEW_EXPENSE_CATEGORY:
        return {
          ...state,
          loading: true,
        };
  
      case ADD_EXPENSE_CATEGORY_SUCCESS:
        return {
          ...state,
          loading: false,
          categories: [...state.categories, action.payload],
        };
  
      case ADD_EXPENSE_CATEGORY_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_EXPENSE_CATEGORY:
        return {
          ...state,
          loading: true,
        };
  
      case UPDATE_EXPENSE_CATEGORY_SUCCESS:
        return {
          ...state,
          loading: false,
          categories: state.categories.map(category =>
            category.id === action.payload.id ? action.payload : category
          ),
        };
  
      case UPDATE_EXPENSE_CATEGORY_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case ADD_NEW_EXPENSE:
        return {
          ...state,
          loading: true,
        };
  
      case ADD_EXPENSE_SUCCESS:
        return {
          ...state,
          loading: false,
          expenses: [...state.expenses, action.payload],
        };
  
      case ADD_EXPENSE_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_EXPENSE:
        return {
          ...state,
          loading: true,
        };
  
      case UPDATE_EXPENSE_SUCCESS:
        return {
          ...state,
          loading: false,
          expenses: state.expenses.map(expense =>
            expense.id === action.payload.id ? action.payload : expense
          ),
        };
  
      case UPDATE_EXPENSE_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default expenseReducer;